// import Select from "react-select";
import Creatable from "react-select/creatable";

import DatePicker from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { DateObject } from "react-multi-date-picker";
import { useEffect, useState, useContext } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import { translateToReactSelect } from "utils/helperFunctions";
import toast from "react-hot-toast";
import toastFunction from "utils/toast";
import React from "react";
import chroma from "chroma-js";
import Modal from "react-bootstrap/Modal";
import Select, { StylesConfig } from "react-select";

import sendRequest from "hooks/useAxios";
import { sendRequestHashtags } from "hooks/useAxios";
import { sendRequestHashtag } from "hooks/useAxios";
import sendRequest2 from "hooks/useAxios2";

import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import Loader from "utils/Loader";
import { AiTwotoneEdit } from "react-icons/ai";
import logo from "assets/images/sitelogo.svg";
const EditProductModal = ({
  selectedProduct,
  setSelectedProduct,
  value,
  update,
  setUpdate,
  show,
  setShow
}) => {
  const auth = useContext(WithAuthentication);
  const [editProduct, setEditProduct] = useState({ ...selectedProduct });
  const [productTag, setProductTag] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hashtagsListOption, setHashtagsListOption] = useState([]);
  useEffect(() => {
    setIsLoading(true);
    async function pageLoad() {
      await sendRequestHashtags("get_main_hashtag").then(data => {
        let temp =
          data?.data?.data?.length > 0 ? [...data?.data?.data?.reverse()] : [];
        let x = ["689", "376", "691"];
        let subgroup = [];
        for (let i = 0; i < temp.length; i++) {
          for (let a = 0; a < x.length; a++) {
            if (temp[i].hashtag.id == x[a]) {
              for (let j = 0; j < temp[i].subs.length; j++) {
                let objects = {
                  label: temp[i].subs[j].txt,
                  value: temp[i].subs[j].id
                };
                subgroup.push(objects);
              }

              setHashtagsListOption(subgroup);
            }
          }
        }
      });
      setIsLoading(false);
    }
    pageLoad();
  }, []);
  useEffect(() => {
    // if (editProduct?.id != selectedProduct?.id) {
    setEditProduct(selectedProduct);
    // }
  }, [selectedProduct]);
  const [mainSupplier, setMainSupplier] = useState([
    { label: "همه", value: "-1" },
    { label: "هیچکس", value: "-2" }
  ]);

  useEffect(() => {
    sendRequest("Find_businesses", {
      conditions: "status/=/0@@type/=/0"
    }).then(data => {
      setMainSupplier([
        ...mainSupplier,
        ...data.data.map(value => {
          return {
            label: value.title,
            value: value.id
          };
        })
      ]);
    });
  }, []);
  const showSeller = () => {
    let x = [];
    x = mainSupplier.filter(v => v.value == editProduct.main_seller);
    return x;
  };
  // const showSubgroup = () => {
  //   let y = [];
  //   // for (let i = 0; i < editProduct.hashtags?.length; i++) {
  //   y = tagsOptions.filter(
  //     v =>
  //       editProduct.hashtags.findIndex(val => val.hashtag_id == v.value) !== -1
  //   );
  //   // }
  //   return y;
  // };
  // const [subgroup, setSubgroup] = useState([]);
  // useEffect(() => {
  //   if (productTag.length > 0) {
  //     sendRequest("Find_hashtagsLinks", {
  //       conditions: `hashtags_links.parent_id/in/${productTag
  //         .map(v => v.value)
  //         .join(",")}`,
  //       tbl_name: "Inner join,hashtags,hashtag_id,id"
  //       // fields:"hashtags.id,hashtags.txt"
  //     }).then(data => {
  //       setSubgroup(
  //         data.data.map(v => {
  //           return {
  //             label: v.txt,
  //             value: v.hashtag_id
  //           };
  //         })
  //       );
  //     });
  //   }
  // }, [productTag]);
  useEffect(() => {
    if (editProduct.hashtags?.length > 0) {
      setProductTag(
        editProduct.hashtags.map(value => {
          if (
            typeof value.value !== "undefined" &&
            typeof value.label !== "undefined"
          ) {
            return value;
          }
          return {
            value: value.hashtags_id,
            label: value.txt
          };
        })
      );
    }
  }, [editProduct]);
  const inputChanged = e => {
    let value = removeCommas(e.target.value);
    let name = e.target.name;
    try {
      if (isNaN(value)) throw new Error("لطفا عدد را به درستی وارد نمایید.");
      setEditProduct(prev => {
        return {
          ...prev,
          [name]: +value
        };
      });
    } catch (ex) {
      toastFunction("error", ex.message);
    }
  };
  const saveData = () => {
    let fd = new FormData();
    fd.append(
      "updateValue",
      `title,${editProduct.title}@@description,${editProduct.description}@@bodytxt,${editProduct.bodytxt}@@price_from,${editProduct.price_from}@@price_to,${editProduct.price_to}@@main_seller,${editProduct.main_seller}@@Interest_rates,${editProduct.Interest_rates}@@shop_commission,${editProduct.shop_commission}@@mainshop_commission,${editProduct.mainshop_commission}`
    );
    fd.append("productId", editProduct.id);

    fd.append(
      "Hashtags",
      editProduct.hashtags.map(v => v.hashtags_id).join(",")
    );
    fd.append("file", editProduct.file);
    if (editProduct.files != undefined) {
      for (let i = 0; i < editProduct.files.length; i++) {
        fd.append("files[]", editProduct.files[i]);
      }
    }

    sendRequest("update_main_product", fd).then(data => {
      if (data.data.status == 1) {
        toastFunction("success", "محصول با موفقیت ایجاد شد.");

        setUpdate(prev => {
          return !prev;
        });
        document.querySelector("#editProductModal .btn-close").click();
      } else {
        toastFunction("error", "مشکلی در ویرایش محصول به وجود آمد.");
      }
    });
  };

  const [tags, setTags] = useState([]);
  useEffect(() => {
    sendRequestHashtag("get_sub_hashtag").then(({ data }) => {
      setTags(data.data);
    });
  }, []);
  const [selectedHashtag, setSelectedHashtag] = useState([]);

  const showHashtag = () => {
    if (editProduct.hashtags?.length > 0) {
      let x = [];
      let y = {};
      for (let i = 0; i < editProduct.hashtags.length; i++) {
        y = {
          value: editProduct.hashtags[i].hashtags_id,
          label: editProduct.hashtags[i].txt
        };
        x.push(y);
      }

      // setSelectedHashtag(x);
      return x;
    }
  };
  const [tagsOptions, setTagsOptions] = useState([]);

  useEffect(() => {
    setTagsOptions(translateToReactSelect(tags, false));
  }, [tags]);

  const insertHashtags = async () => {
    let theArr = [];

    await Promise.all(
      productTag.map(async arrayItem => {
        if (arrayItem.__isNew__ == true) {
          await sendRequest("Insert_hashtags", { txt: arrayItem.label }).then(
            ({ data }) => {
              theArr.push(data.result.id);
            }
          );
        } else {
          theArr.push(+arrayItem.value);
        }
      })
    );
    return theArr;
  };

  // validation
  const [validateStatus, setValidateStatus] = useState({
    title: false,
    // cover: false,
    productTag: false,
    main_seller: false,
    price_from: false,
    price_to: false,
    Interest_rates: false,
    shop_commission: false,
    mainshop_commission: false,
    checkPrice: false
  });

  const validation = () => {
    let isValid = true;
    if (editProduct.title == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, title: true };
      });
    }
    if (editProduct.price_to < editProduct.price_from) {
      isValid = false;
      setValidateStatus({ ...validateStatus, checkPrice: true });
      console.log("checkPrce", validateStatus.checkPrice);
    } else {
      isValid = true;
      setValidateStatus({ ...validateStatus, checkPrice: false });
    }
    if (editProduct.file == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, cover: true };
      });
    } else {
      setValidateStatus(prev => {
        return { ...prev, cover: false };
      });
    }
    if (editProduct.price_from == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, price_from: true };
      });
    }
    if (editProduct.price_to == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, price_to: true };
      });
    }
    if (editProduct.Interest_rates == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, Interest_rates: true };
      });
    }
    if (editProduct.shop_commission == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, shop_commission: true };
      });
    }
    if (editProduct.mainshop_commission == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, mainshop_commission: true };
      });
    }
    if (editProduct.main_seller == "") {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, main_seller: true };
      });
    } else {
      setValidateStatus(prev => {
        return { ...prev, main_seller: false };
      });
    }
    if (editProduct.hashtags?.length <= 0) {
      isValid = false;
      setValidateStatus(prev => {
        return { ...prev, productTag: true };
      });
    } else {
      setValidateStatus(prev => {
        return { ...prev, productTag: false };
      });
    }
    return isValid;
  };

  return (
    <>
      {/* <button
        type="button"
        className="btn p-0 mx-1 product-action"
        data-bs-toggle="modal"
        data-bs-target="#editProductModal"
        onClick={() => {
          setSelectedProduct(value);
          // setShow(true);
        }}
        data-for="gm-tooltip"
        data-tip="ویرایش محصول"
      >
        <AiTwotoneEdit />
      </button> */}
      {/* <Modal
        // keyboard={true}
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
        centered
      > */}
      <div className="modal" id="editProductModal" tabIndex={-1}>
        <div className="modal-dialog modal-lg modal-fullscreen-lg-down">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">ویرایش محصول </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            {/* <Modal.Header closeButton>
                <h5 className="modal-title">ویرایش محصول </h5>
              </Modal.Header> */}
            <div className="modal-body">
              {/* <Modal.Body> */}
              <form name="editProduct">
                <nav>
                  <div class="nav nav-tabs" id="nav-tab" role="tablist">
                    <button
                      class="nav-link active"
                      id="nav-info-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-info"
                      type="button"
                      role="tab"
                      aria-controls="nav-info"
                      aria-selected="true"
                    >
                      اطلاعات اولیه
                    </button>
                    <button
                      class="nav-link"
                      id="nav-sale-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-sale"
                      type="button"
                      role="tab"
                      aria-controls="nav-sale"
                      aria-selected="false"
                    >
                      اطلاعات فروش
                    </button>
                    <button
                      class="nav-link"
                      id="nav-more-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#nav-more"
                      type="button"
                      role="tab"
                      aria-controls="nav-more"
                      aria-selected="false"
                    >
                      اطلاعات تکمیلی
                    </button>
                  </div>
                </nav>
                <div class="tab-content" id="nav-tabContent">
                  {/* محتوا اطلاعات اولیه */}
                  {isLoading && <Loader />}
                  <div
                    class="tab-pane fade show active"
                    id="nav-info"
                    role="tabpanel"
                    aria-labelledby="nav-info-tab"
                  >
                    <div className="d-flex first-container">
                      {/* عنوان */}
                      <div className="my-2 mx-1 align-items-baseline title">
                        <label for="title" className="">
                          عنوان:
                        </label>
                        <input
                          id="title"
                          className="round form-control"
                          type="text"
                          // defaultValue={product.title}
                          value={editProduct?.title}
                          required
                          onChange={e => {
                            setEditProduct(prev => {
                              return { ...prev, title: e.target.value };
                            });
                          }}
                          onKeyUp={() => {
                            if (editProduct.title == "") {
                              setValidateStatus(prev => {
                                return { ...prev, title: true };
                              });
                            } else {
                              setValidateStatus(prev => {
                                return { ...prev, title: false };
                              });
                            }
                          }}
                        ></input>
                        <div
                          className={`ms-1 ${
                            validateStatus.title == true ? "d-block" : "d-none"
                          } validation-txt`}
                        >
                          فیلد عنوان نباید خالی باشد.
                        </div>
                      </div>
                      {/* کاور */}
                      <div className="my-2 mx-1 align-items-baseline other-media">
                        <label for="coverPic" className="">
                          کاور محصول:
                        </label>
                        <input
                          id="coverPic"
                          className=" form-control "
                          type="file"
                          onChange={e => {
                            setEditProduct(prev => {
                              return { ...prev, file: e.target.files[0] };
                            });
                          }}
                        ></input>

                        <div
                          className={`ms-1 ${
                            validateStatus.cover == true ? "d-block" : "d-none"
                          } validation-txt`}
                        >
                          فیلد کاور نباید خالی باشد.
                        </div>
                      </div>
                    </div>

                    <div className="d-flex my-2 mx-1 align-items-baseline ">
                      {/* زیرگروه کالا */}
                      {auth.userInfo.userType == 0 && (
                        <div className="my-2 title">
                          <label for="tags1">زیرگروه کالایی:</label>

                          <Select
                            id="tags1"
                            options={tagsOptions}
                            isMulti={true}
                            className="mx-1"
                            value={showHashtag()}
                            onChange={e => {
                              setProductTag(e);
                              setEditProduct(prev => ({
                                ...prev,
                                hashtags: e.map(val => ({
                                  hashtags_id: val.value,
                                  txt: val.label
                                }))
                              }));
                              console.log("producttag :", productTag);
                            }}
                          />
                          <div
                            className={`ms-1 ${
                              validateStatus.productTag == true
                                ? "d-block"
                                : "d-none"
                            } validation-txt`}
                          >
                            فیلد زیرگروه کالایی نباید خالی باشد.
                          </div>
                        </div>
                      )}
                      {/* زیرگروه کالا */}
                      {auth.userInfo.userType == 3 && (
                        <div className="my-2 title">
                          <label for="tags2">زیرگروه کالایی:</label>

                          <Select
                            id="tags2"
                            options={hashtagsListOption}
                            isMulti={true}
                            className="mx-1"
                            value={showHashtag()}
                            onChange={e => {
                              setProductTag(e);
                              setEditProduct(prev => ({
                                ...prev,
                                hashtags: e.map(val => ({
                                  hashtags_id: val.value,
                                  txt: val.label
                                }))
                              }));
                              console.log("producttag :", productTag);
                            }}
                          />
                          <div
                            className={`ms-1 ${
                              validateStatus.productTag == true
                                ? "d-block"
                                : "d-none"
                            } validation-txt`}
                          >
                            فیلد زیرگروه کالایی نباید خالی باشد.
                          </div>
                        </div>
                      )}
                      {/* انتخاب تامین کننده */}
                      <div className="my-2 mx-1 title align-items-baseline">
                        <label htmlFor="edit-supplier">
                          انتخاب تامین کننده :
                        </label>
                        <Select
                          id="edit-supplier"
                          options={mainSupplier}
                          // value={editProduct.main_seller}
                          value={showSeller()}
                          onChange={e => {
                            setEditProduct(prev => {
                              return { ...prev, main_seller: e.value };
                            });
                          }}
                        />
                        <div
                          className={`ms-1 ${
                            validateStatus.main_seller == true
                              ? "d-block"
                              : "d-none"
                          } validation-txt`}
                        >
                          فیلد تامین کننده نباید خالی باشد.
                        </div>
                      </div>
                    </div>
                    {/* تگهای محصول
                        <div className="my-2 title">
                          <label for="tags">گروه کالایی:</label>
                          
                          <Select
                            id="tags"
                            options={tagsOptions}
                            isMulti={true}
                            className="mx-1"
                            value={productTag}
                            // value={tagsOptions.filter(
                            //   value =>
                            //     editProduct?.hashtags?.find(
                            //       val => val.hashtag_id == value.value
                            //     ) ||
                            //     productTag?.find(
                            //       val => val.value == value.value
                            //     )
                            // )}
                            onChange={e => {
                              console.log("hashtag : ", e);
                              setEditProduct(prev => {
                                return {
                                  ...prev,
                                  hashtags: e
                                };
                              });
                              setProductTag(e);                             
                            }}
                          />
                        </div> */}

                    {/* توضیحات */}
                    <div className="my-2 align-items-baseline">
                      <label for="txt" className="">
                        توضیحات:{" "}
                      </label>
                      <textarea
                        id="txt"
                        className=" form-control"
                        value={editProduct.description}
                        onChange={e => {
                          setEditProduct(prev => {
                            return { ...prev, description: e.target.value };
                          });
                        }}
                      ></textarea>
                    </div>

                    <div className="d-flex second-container">
                      {/* فایلهای جانبی */}
                      {/* <div className="my-2 mx-1 align-items-baseline cover ">
                          <label for="otherMedia">فایلهای جانبی:</label>
                          <input
                            className="form-control"
                            id="otherMedia"
                            type="file"
                            multiple
                            onChange={e => {
                              setEditProduct(prev => {
                                return { ...prev, files: e.target.files };
                              });
                              console.log("images2", editProduct.files);
                            }}
                          ></input>
                   
                        </div> */}
                    </div>
                  </div>

                  {/* محتوا اطلاعات فروش */}
                  <div
                    className="tab-pane fade "
                    id="nav-sale"
                    role="tabpanel"
                    aria-labelledby="nav-sale-tab"
                  >
                    <div className="mt-5">
                      <div className="d-flex flex-wrap">
                        <div className=" title">
                          <div className=" my-2 me-3">
                            <label htmlFor="productPriceFrom">
                              حداقل قیمت(تومان):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="productPriceFrom"
                              name="price_from"
                              value={addCommas(editProduct.price_from)}
                              onChange={e => {
                                inputChanged(e);
                                // let value = removeCommas(e.target.value);
                                // try {
                                //   if (isNaN(value))
                                //     throw new Error(
                                //       "لطفا عدد را به درستی وارد نمایید."
                                //     );
                                //   setAddProduct(prev => {
                                //     return {
                                //       ...prev,
                                //       default_price: +value
                                //     };
                                //   });
                                // } catch (ex) {
                                //   toast.error(ex.message);
                                // }
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.price_from == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد قیمت نباید خالی باشد.
                            </div>
                          </div>
                        </div>
                        <div className=" title">
                          <div className=" my-2 me-3">
                            <label htmlFor="productPriceTo">
                              حداکثر قیمت(تومان):
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="productPriceTo"
                              name="price_to"
                              value={addCommas(editProduct.price_to)}
                              onChange={e => {
                                inputChanged(e);
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.price_to == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد قیمت نباید خالی باشد.
                            </div>
                            <div
                              className={`ms-1 ${
                                validateStatus.checkPrice == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              حداکثر قیمت نمی تواند از حداقل قیمت کمتر باشد
                            </div>
                          </div>
                        </div>
                        <div className=" title">
                          <div className="my-2 me-3">
                            <label htmlFor="benefitStore">
                              درصد سود فروشگاه :
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="benefitStore"
                              name="Interest_rates"
                              value={addCommas(editProduct.Interest_rates)}
                              onChange={e => {
                                inputChanged(e);
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.Interest_rates == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد درصد نباید خالی باشد.
                            </div>
                          </div>
                        </div>
                        <div className=" title">
                          <div className=" my-2 me-3">
                            <label htmlFor="commissionShop">
                              کمیسیون فروشگاه :
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="commissionShop"
                              name="shop_commission"
                              value={addCommas(editProduct.shop_commission)}
                              onChange={e => {
                                inputChanged(e);
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.shop_commission == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد کمیسیون فروشگاه نباید خالی باشد.
                            </div>
                          </div>
                        </div>

                        <div className=" title">
                          <div className=" my-2 me-3">
                            <label htmlFor="commissionSupplier">
                              کمیسیون تامین کننده :
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="commissionSupplier"
                              name="mainshop_commission"
                              value={addCommas(editProduct.mainshop_commission)}
                              onChange={e => {
                                inputChanged(e);
                              }}
                            />
                            <div
                              className={`ms-1 ${
                                validateStatus.mainshop_commission == true
                                  ? "d-block"
                                  : "d-none"
                              } validation-txt`}
                            >
                              فیلد کمیسیون تامین کننده نباید خالی باشد.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* محتوا اطلاعات تکمیلی */}
                  <div
                    class="tab-pane fade"
                    id="nav-more"
                    role="tabpanel"
                    aria-labelledby="nav-more-tab"
                  >
                    <div className="my-3" dir="">
                      <SunEditor
                        setOptions={{
                          height: 250,
                          buttonList: [
                            [],
                            [
                              "undo",
                              "redo",
                              "font",
                              "fontSize",
                              "formatBlock",
                              "bold",
                              "underline",
                              "strike",
                              "fontColor",
                              "textStyle",
                              "removeFormat",
                              "align",
                              "horizontalRule",
                              "list",
                              "lineHeight",
                              "link",
                              "image",
                              "video",
                              "audio",
                              "imageGallery",
                              "fullScreen",
                              "preview"
                            ]
                          ] // Or Array of button list, eg. [['font', 'align'], ['image']]
                        }}
                        setContents={editProduct.bodytxt}
                        value={editProduct.bodytxt}
                        onChange={content => {
                          setEditProduct(prev => {
                            return { ...prev, bodytxt: content };
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>

                <div className="text-center">
                  <button
                    type="button"
                    className="btn btn-success px-4"
                    onClick={async () => {
                      console.log("validation : ", validation());
                      if (validation()) {
                        let x = await insertHashtags();
                        saveData(x);
                        // saveData();
                      }
                    }}
                  >
                    ویرایش
                  </button>
                </div>
              </form>
            </div>
            {/* </Modal.Body> */}
          </div>
        </div>
      </div>
      {/* </Modal> */}
    </>
  );
};

export default EditProductModal;
